export default "__VITE_ASSET__BeLlnpE7__"